import { render } from "./BaseTooltip.vue?vue&type=template&id=17fc891a&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=17fc891a&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fc891a"]])

export default __exports__